import React from 'react';
import assset from './step-1-placeholder.png';
import { Image, VideoWrapper } from './styled';
import { FadeLayer } from './../../styled';

const wrapperStyle = {
  position: 'relative',
  display: 'flex',
  width: '100%',
  height: '100%'
};

class Step1 extends React.Component {
  constructor() {
    super();
    this.startVideo = this.startVideo.bind(this);
    this.videoListener = this.videoListener.bind(this);
  }

  startVideo = () => {
    let video = document.querySelector('video');
    video.play();
  };

  videoListener = () => {
    this.props.selectStep(2);
  };

  render() {
    if (this.props.currentStep !== 1) {
      return null;
    }
    return (
      <div style={wrapperStyle}>
        <FadeLayer />
        <VideoWrapper>
          {this.props.navigated
            ? <img
                src="https://cdn.auth0.com/website/homepage/01_mobile_use_case.svg"
                alt="Use cases"
              />
            : <video
                muted={'true'}
                autoPlay={'true'}
                onLoadedData={this.startVideo}
                onEnded={this.videoListener}
                src="https://videos.ctfassets.net/2ntc334xpx65/2QnoUWz1Reui2EegQWam6q/a3d5be6cdf84fb0ce68c8890b42107ad/01_Use_Cases.mp4"
              />}
        </VideoWrapper>
      </div>
    );
  }
}

export default Step1;



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/components/Step1/Step1.js